/**
 * UserManagement Page Barrel Export
 * 
 * This barrel export file follows the established ECP directory-level import pattern
 * for the UserManagement page component. It enables clean imports of the UserManagement
 * component from the page directory level.
 * 
 * Usage:
 * import UserManagement from 'src/pages/UserManagement'
 * 
 * This pattern is consistent with other page components in the ECP client application
 * and maintains the standard React page architecture structure.
 */

import UserManagement from './UserManagement'

export default UserManagement